import { Injectable, OnDestroy } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { FacebookPixelService } from './facebook-pixel.service';
import { GoogleAnalyticsService } from './google-analytics.service';
import { Subscription } from 'rxjs';
import { TiktokPixelService } from './tiktok-pixel.service';

@Injectable({
  providedIn: 'root'
})
export class RoutingInterceptorService implements OnDestroy {
  private subscription: Subscription | undefined

  constructor(
    private facebookPixelService: FacebookPixelService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private tiktokService: TiktokPixelService,
    private router: Router,
  ) { }

  init() {
    this.subscription = this.router.events.subscribe((event: Event) => {
      this.navigationInterceptor(event);
    });
  }

  navigationInterceptor(event: Event): void {
    if (event instanceof NavigationEnd) {
      this.googleAnalyticsService.pageViewEvent(event.urlAfterRedirects);
      this.facebookPixelService.fbPageView();
      this.tiktokService.pageView();
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
